// extracted by mini-css-extract-plugin
module.exports = {"root":"YHgn3","closeButton":"_1tcxq","title":"_2Gt1P","subtitle":"_2i2lY","ctaButton":"DaqQU"};